import React from 'react';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { TEXT_KEY, getText } from 'shared/utils/localization';
import { useTheme } from 'styled-components';
import {
  BottomBar,
  BottomBarFirstLine,
  BottomBarSecondContainer,
  BottomBarSecondLine,
  BottomBarThirdLine,
  FooterText,
} from '../../styledComponents';

const DefaultBottomBar = ({ onAccountActivate, withGuest, onGuestActivate, isGuestLoginButton }) => {
  const { Start } = useTheme();
  return (
    <BottomBar background={assetSource(ASSET_KEY.DAILY_BONUS_PRIZES_BOTTOM_BAR)}>
      <BottomBarFirstLine>{getText(TEXT_KEY.ALREADY_HAVE_ACCOUNT)}</BottomBarFirstLine>
      <BottomBarSecondContainer>
        <div onClick={onAccountActivate}>
          <BottomBarSecondLine>{getText(TEXT_KEY.LOG_IN_HERE)}</BottomBarSecondLine>
        </div>
        {withGuest && !isGuestLoginButton && (
          <BottomBarThirdLine qa-id="playAsGuestBtn" onClick={onGuestActivate}>
            {getText(TEXT_KEY.PLAY_AS_GUEST)}
          </BottomBarThirdLine>
        )}
        {getText(TEXT_KEY.FOOTER_TEXT) !== '' && (
          <FooterText theme={Start.BottomBarFooterText}>{getText(TEXT_KEY.FOOTER_TEXT)}</FooterText>
        )}
      </BottomBarSecondContainer>
    </BottomBar>
  );
};

export default DefaultBottomBar;

